export enum ProductFeatures {
    DermatologicallyTested = 'Dermatologically Tested',
    SingleWrapped = 'Single Wrapped',
    HasWings = 'Has Wings',
    BreathableBackMaterial = 'Breathable back material'
}
